import React from 'react';
import { Slider, Whisper, Tooltip, Button } from 'rsuite';
import { FORM_FIELDS } from '../../../utils/merchantUtils';
import { CONFIGURATIONS_FORM_FIELDS_NAMES } from '../../../constants/merchant/configurations-form';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../../developers/page-components/WhisperComponent';
import { useTranslation } from 'react-i18next';

import './RiskLevel.scss';

interface Props {
    formik: any;
    isEditMode?: boolean;
    fieldName: string;
    title: string;
}



export const RiskLevelSlider = (props: Props): React.ReactElement => {
    const { t } = useTranslation();

    const { formik, isEditMode, fieldName, title } = props;

    // const value = formik.getFieldProps(FORM_FIELDS.RISK_LEVEL).value;
    const value = formik.getFieldProps(fieldName).value;

    return (
        <div className={clsx('w-300px', 'mb-5')}>
            {/*<Label fieldLabel={CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_LEVEL} isStandardClass additionalClass='mb-5'/>*/}
            {/*<span className="mb-5">{t(CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_LEVEL)} {getValueDescription(value)}</span>*/}
            <span className={clsx('mb-5', !isEditMode && 'text-muted')}>{title} {getValueDescription(value)}</span>
            <WhisperComponent
                isTooltip
                whisperText={'This parameters allows you to adjust the risk level settings for merchant account. By enabling or adjusting this setting, you can define the threshold for declining potentially risky transactions based on various criteria.'}
                mainText={
                    <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className={clsx('cursor-pointer ms-1', !isEditMode && 'text-muted')}
                        width={12}
                    />
                }
            />

            <div className="row align-items-center" style={{ padding: '15px 5px' }}>
                <div>
                    {/*<Slider*/}
                    {/*    className="risk-level-slider"*/}
                    {/*    progress*/}
                    {/*    value={value}*/}
                    {/*    max={100}*/}
                    {/*    onChange={(value): void => formik.setFieldValue(FORM_FIELDS.RISK_LEVEL, value)}*/}
                    {/*    disabled={!isEditMode}*/}
                    {/*    // step={1}*/}
                    {/*    graduated*/}
                    {/*    tooltip*/}
                    {/*    // handleTitle={}*/}
                    {/*    renderMark={(mark: any): string | null => {*/}
                    {/*        console.log('mark---', mark);*/}
                    {/*        // if ([64, 128, 256, 512, 1024].includes(mark)) {*/}
                    {/*        //     return <span>{mark} GB</span>;*/}
                    {/*        // }*/}
                    {/*        return getLabel(mark);*/}
                    {/*    }}*/}
                    {/*/>*/}

                    <Slider
                        className="risk-level-slider"
                        progress
                        value={value}
                        max={81}
                        min={1}
                        onChange={(value): void => formik.setFieldValue(fieldName, value)}
                        disabled={!isEditMode}
                        step={16}
                        graduated
                        tooltip={false}
                        // handleTitle={}
                        renderMark={(mark: any): any => {
                            const tooltip = (
                                <Tooltip>
                                    {getTooltip(mark)}
                                </Tooltip>
                            );

                            return (
                                <Whisper placement="top" trigger="hover" speaker={tooltip}>
                                    <span>{getLabel(mark)}</span>
                                </Whisper>
                            );
                        }}

                    />
                </div>
            </div>
        </div>
    );
};

const getValueDescription = (value: number | null): string => {
    if (value === null) return '';

    // if (value < 16) return '(A)';
    // if (value >= 25 && value < 50) return '(B)';
    // if (value >= 50 && value < 75) return '(C)';
    // if (value >= 75) return '(D)';

    if (value === 1) return '(Insignificant)';
    if (value === 17) return '(Very low)';
    if (value === 33) return '(Low)';

    if (value === 49) return '(Medium)';
    if (value === 65) return '(High)';
    if (value === 81) return '(Very high)';
};

const getLabel = (value: number | null): string => {
    if (value === null) return null;

    if (value === 1) return 'A';
    if (value === 17) return 'B';
    if (value === 33) return 'C';

    if (value === 49) return 'D';
    if (value === 65) return 'E';
    if (value === 81) return 'F';
};

const getTooltip = (value: number | null): string => {
    if (value === null) return null;

    if (value === 1) return 'Insignificant risk';
    if (value === 17) return 'Very low risk';
    if (value === 33) return 'Low risk';

    if (value === 49) return 'Medium risk';
    if (value === 65) return 'High risk';
    if (value === 81) return 'Very high risk';
};
